import type { NotificationItem } from "./api";

export const FRONTEND_PREFIXES = [
  "/community",
  "/classmate",
  "/workmate",
  "/informate",
  "/timetable",
  "/notifications",
  "/messages",
  "/account",
  "/follows",
  "/points",
];

export function resolveNotificationUrl(
  n: NotificationItem
): { href: string; isSpa: boolean } | undefined {
  if (!n.url) return undefined;

  let url = n.url.startsWith("/common/follows")
    ? "/follows" + n.url.slice("/common/follows".length)
    : n.url;

  if (url.startsWith("http")) return { href: url, isSpa: false };

  if (FRONTEND_PREFIXES.some((p) => url.startsWith(p))) {
    return { href: url, isSpa: true };
  }

  return undefined;
}

export function getNotificationIcon(app: string): string {
  switch (app) {
    case "teacher_jobs": return "📍";
    case "school_question":
    case "school_answer":
      return "🏫";
    case "follow":
      return "👤";
    case "community_like":
      return "❤️";
    case "community_comment":
      return "💬";
    case "community_reply":
      return "↩️";
    case "informate_vibe_like":
      return "✨";
    case "informate_vibe_comment":
    case "informate_vibe_reply":
      return "💬";
    case "community_following_post":
      return "📝";
    case "message":
    case "messages":
      return "✉️";
    case "points_grant":
      return "🪙";
    case "credit_bank":
      return "🎟️";
    case "points_gift":
      return "🎁";
    case "points_attendance":
      return "🏆";
    case "training_certs_share":
      return "🎓";
    case "file_inbox_share":
      return "📂";
    case "receipts_share":
      return "🧾";
    case "timetable_swap":
      return "🔄";
    case "timetable_invite":
      return "✉️";
    case "timetable_share":
      return "📅";
    default:
      return "🔔";
  }
}

export function getNotificationAppLabel(app: string): string | null {
  switch (app) {
    case "teacher_jobs": return "교원 공고";
    case "school_question": return "학교 질문";
    case "school_answer": return "학교 답변";
    case "training_certs_share":
      return "연수 이수증";
    case "file_inbox_share":
      return "AI 파일 수합";
    case "receipts_share":
      return "영수증 정리";
    case "timetable_swap":
      return "시간표 교체";
    case "timetable_invite":
      return "교사 초대";
    case "timetable_share":
      return "시간표 공유";
    case "messages":
    case "message":
      return "쪽지";
    case "points_gift":
      return "포인트 선물";
    case "points_grant":
      return "포인트";
    case "credit_bank":
      return "이용권";
    case "points_attendance":
      return "출석 포인트";
    case "follow":
      return "팔로우";
    default:
      return null;
  }
}
